import React from 'react';
import PropTypes from 'prop-types';
import { Images } from '../Images';
import { StyledEmptyState, StyledText } from './styled';

const EmptyStateMessage = ({ message = '', isShowImage = true }) => (
  <StyledEmptyState>
    {isShowImage && <Images.NoDataFoundLight width="50%" />}
    <StyledText>{message}</StyledText>
  </StyledEmptyState>
);

EmptyStateMessage.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
  isShowImage: PropTypes.bool
};

export default EmptyStateMessage;
